import { useDependencyInjection } from "../../../../config/di/dependency_injection_context";
import { usePageLoader } from "../../../../common/contexts/page_content_context";
import {  useCallback, useState } from "react";
import { usePageStartBootstrap } from "../../../../common/hooks/use_page_start_bootstrap";
import { processError } from "../../../../common/utils/base_error";
import { useCreateDebounceHandler, useDebouncedCallback } from "../../../../common/hooks/use_debounced_callback";
import { useAcoesMelhoriasFilters } from "../hooks/Qualidade_acoes_melhorias/filter";
import { useAcoesMelhoriasPagination } from "../hooks/Qualidade_acoes_melhorias/pagination";
import {  AcoePreventivasLista } from "../../domain/models/acoes_melhorias_lista";
import { evaluateParamValue } from "../../../../common/utils/params_utils";
import { useDropDownLoader } from "../../../../common/hooks/use_dropdown_loader";
import { useNavigate, useParams } from "react-router";
import { useReportViewer } from "../../../../config/hooks/utils/report_viewer";

type LoadAcoesMelhoriasListaFuncState = {
  IdAcaoQualidade?: number;
  page?: number;
  rowsPerPage?: number;
  tipoPesquisa?: number,
  status?: number,
  pesquisa?: string | number | Date,
  centroDeCusto?: number[],
  
};


export const useQualidadeAcoesMelhoriasViewModel = () => {
  const {
    commons: { },
    reports: {getReportAcoesPreventivasUseCase},
    qualidade: { getAllListagemAcoesMelhoriasUseCase, deleteAcoesPreventivasUseCase }
   
  } = useDependencyInjection();

   const {
      loadCentroCustoDropDown,
    } = useDropDownLoader();
  
  const { status } = useParams();

  const [loading, setLoading] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [acoesMelhoriasLista, setAcoesMelhoriasLista] = useState<AcoePreventivasLista[]>([])
  const [selectedacoesMelhorias, setSelectedAcoesMelhorias] = useState<AcoePreventivasLista>()

  //Arquivo
  const [acoesMelhoriasDeleteModal, setAcoesMelhoriasDeleteModal] = useState<boolean>(false);
  const [openDeleteArquivoModal, setOpenDeleteArquivoModal] = useState<boolean>(false);

  const {pushErrorNotification, setCustomLoading } = usePageLoader();
  const debouncedRef = useCreateDebounceHandler(750);
    const navigate = useNavigate();

  const filters = useAcoesMelhoriasFilters();
  const pagination = useAcoesMelhoriasPagination();
  
  //#region Relatorio
    const [reportViewerState, startReportViewerProcess] = useReportViewer();
  //#endregion

  // #region Funções de carregamento

  const loadAcoesMelhoriasListaState = useCallback(async (funcState?: LoadAcoesMelhoriasListaFuncState) => {
      try {
        if(status !== undefined && status !== null) filters.status = Number(status);
        
        const filterID_Acoes_Melhorias = evaluateParamValue(funcState?.IdAcaoQualidade, filters.IdAcaoQualidade);
        const filteredPage = funcState?.page ?? pagination.page;
        const filteredRowsPerPage = funcState?.rowsPerPage ?? pagination.rowsPerPage;
        const filteredTipoPesquisa = funcState?.tipoPesquisa ?? filters.tipoPesquisa;
        const filteredPesquisa = funcState?.pesquisa ?? filters.pesquisa;
        const filteredStatus = funcState?.status ?? filters.status;
        const filteredCentroDeCusto = funcState?.centroDeCusto ?? filters.centroDeCusto;
        await getAllListagemAcoesMelhoriasUseCase.getAllListagemAcoesMelhorias(
          {
            IdAcaoQualidade: filterID_Acoes_Melhorias,Tipo: 0, PesquisarPor: filteredTipoPesquisa, Pesquisar: String(filteredPesquisa ), status: filteredStatus, centroDeCusto: filteredCentroDeCusto,
          },
          filteredPage,
          filteredRowsPerPage
        );
        setAcoesMelhoriasLista(getAllListagemAcoesMelhoriasUseCase.items);
        pagination.setRowsPerPage(getAllListagemAcoesMelhoriasUseCase.pageSize);
        pagination.setTotalItems(getAllListagemAcoesMelhoriasUseCase.totalItems);
       
      } catch (e: unknown) {
          throw new Error("Falha ao Ações Melhorias!");
      }
    }, [filters, getAllListagemAcoesMelhoriasUseCase, pagination, status]);


  //#endregion

  // #region useEffect
  usePageStartBootstrap(async () => {
    try {
      const jobs = [];
      await loadCentroCustoDropDown(list => useAcoesMelhoriasFilters.setState({ centroDeCustoLista: list }));
      jobs.push(loadAcoesMelhoriasListaState());
      await Promise.all(jobs);
    } catch (e: unknown) {
      setErrorMessage(processError(e, 'Falha ao buscar dados da pagina!')[0]);
    }
  });

  const handleReload = useCallback(async () => {
    try {
      const jobs = [];
      setLoading(true);
      jobs.push(loadAcoesMelhoriasListaState());
      
      await Promise.all(jobs);
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesMelhoriasListaState, pushErrorNotification]);
  //#endregion

  // #region Eventos
  const handlePageChange = useCallback(async (page: number) => {
    try {
      setLoading(true);
      pagination.setPage(page + 1);;
      await loadAcoesMelhoriasListaState({page: page + 1,});
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesMelhoriasListaState, pagination, pushErrorNotification]);

  
  const handleRowsPerPageChange = useCallback(async (rowsPerPage: number) => {
    try {
        setLoading(true);
        pagination.setPage(1);
        pagination.setRowsPerPage(rowsPerPage);
  
        await loadAcoesMelhoriasListaState({ page: 1, rowsPerPage });
    } catch (e: unknown) {
      pushErrorNotification('Erro', processError(e, 'Falha ao buscar dados da pagina!'));
    } finally {
      setLoading(false);
    }
  }, [loadAcoesMelhoriasListaState, pagination, pushErrorNotification]);

   const handleDeleteAcoesMelhoriasModalOpenState = useCallback((IdAcaoQualidade: number | null, openState: boolean) => {
      if (openState) {
        if (IdAcaoQualidade && acoesMelhoriasLista) {
          setSelectedAcoesMelhorias(acoesMelhoriasLista.find(x => x.IdAcaoQualidade === IdAcaoQualidade));
        } else {
          setSelectedAcoesMelhorias(undefined);
        }
      }
      setAcoesMelhoriasDeleteModal(openState);
    }, [acoesMelhoriasLista]);
  

  const handleDeleteConfirmaAcoesMelhorias = useCallback(async () => {
    if (selectedacoesMelhorias) {
        try {
          setSaving(true);
          await deleteAcoesPreventivasUseCase.deleteAcoesPreventivas(selectedacoesMelhorias.IdAcaoQualidade);
          await loadAcoesMelhoriasListaState();
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, 'Falha ao excluir informações!'));
        } finally {
          setSaving(false);
          setAcoesMelhoriasDeleteModal(false);
        }
      }
    }, [deleteAcoesPreventivasUseCase, loadAcoesMelhoriasListaState, pushErrorNotification, selectedacoesMelhorias]);

  

  //#endregion

  //#region Filtros
  const handleClearFilters = useCallback(async () => {
      try {
          setLoading(true);
          filters.clearFilters();
          pagination.setPage(1);
          await loadAcoesMelhoriasListaState();
      } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, 'Falha ao buscar Ações Preventivas!'));
      } finally {
          setLoading(false);
      }
  }, [filters, pagination, loadAcoesMelhoriasListaState, pushErrorNotification]);

  const handlePesquisaChange = useDebouncedCallback( debouncedRef,  (newValue: string | Date | number | null) => {
      useAcoesMelhoriasFilters.getState().setPesquisa(newValue);
      
      if (newValue) {
        return async () => {
          try {
            setLoading(true);
            useAcoesMelhoriasPagination.getState().setPage(1);
            await loadAcoesMelhoriasListaState({ pesquisa: newValue, page: 1 });
          } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
          } finally {
            setLoading(false);
          }
        }
      } else {
        return async () => {
          try {
            setLoading(true);
            useAcoesMelhoriasPagination.getState().setPage(1);
            await loadAcoesMelhoriasListaState(); 
          } catch (e: unknown) {
            pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
          } finally {
            setLoading(false);
          }
        }
      }
    }, 
    [ loadAcoesMelhoriasListaState, pushErrorNotification, setLoading]
  );
  
  const handleTipoPesquisaChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
    useAcoesMelhoriasFilters.getState().setTipoPesquisa(newValue);
    return async () => {
      try {
        setLoading(true);
        useAcoesMelhoriasPagination.getState().setPage(1);
        await loadAcoesMelhoriasListaState({ tipoPesquisa: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadAcoesMelhoriasListaState, pushErrorNotification]);

  const handleStatusChange = useDebouncedCallback(debouncedRef, (newValue: number) => {
      useAcoesMelhoriasFilters.getState().setStatus(newValue);
      return async () => {
      try {
        setLoading(true);
        useAcoesMelhoriasPagination.getState().setPage(1);
        await loadAcoesMelhoriasListaState({ status: newValue, page: 1 });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
      } finally {
        setLoading(false);
      }
    }
  }, [ loadAcoesMelhoriasListaState, pushErrorNotification]);

  const handleCentroDeCustoChange = useDebouncedCallback(debouncedRef, (newValue: number[]) => {
      useAcoesMelhoriasFilters.getState().setCentroDeCusto(newValue);
      return async () => {
        try {
          setLoading(true);
          useAcoesMelhoriasPagination.getState().setPage(1);
          await loadAcoesMelhoriasListaState({ centroDeCusto: newValue, page: 1 });
        } catch (e: unknown) {
          pushErrorNotification("Erro", processError(e, "Falha ao carregar Ações Preventivas!"));
        } finally {
          setLoading(false);
        }
      }
    }, [
      loadAcoesMelhoriasListaState,
      pushErrorNotification,
    ]);

  //#endregion
  
  
  //#region Navegação
  const handleNewAcoesPreventivas = useCallback((tipo: "Corretiva" | "Preventivas", id: number | null) => {
    navigate(`/AcoesPreventivas_Cadastro/${tipo}/${id}`);

  }, [ navigate]);

  //#endregion

   //#region Relatoria
  const handleAcoesPreventivasExportar = useCallback(async (IdAcaoQualidade: number) => {
      try {
        setLoading(true);
         await startReportViewerProcess({
        fetchCallback: async (requiredMimeType) =>
          await getReportAcoesPreventivasUseCase.getReportAcoesPreventivas(IdAcaoQualidade, requiredMimeType ),
      });
      } catch (e: unknown) {
        pushErrorNotification("Erro", processError(e, 'Falha ao gerar relatório de Ações Preventivas!'));
      } finally {
        setLoading(false);
        setCustomLoading(false);
      }
    }, [getReportAcoesPreventivasUseCase, pushErrorNotification, setCustomLoading, startReportViewerProcess]);

  //#endregion
  return {
      loading,
      saving,
      errorMessage,
      openDeleteArquivoModal,
      pagination,
      filters,
      acoesMelhoriasLista,
      acoesMelhoriasDeleteModal,
      reportViewerState,
      handleReload,
      handleRowsPerPageChange,
      handlePageChange,
      handleTipoPesquisaChange,
      handlePesquisaChange,
      handleClearFilters,
      handleStatusChange,
      handleCentroDeCustoChange,
      handleNewAcoesPreventivas,
      handleDeleteAcoesMelhoriasModalOpenState, 
      handleDeleteConfirmaAcoesMelhorias,
      handleAcoesPreventivasExportar
  }
}